module.exports = __webpack_public_path__ + "img/1-name.189ef0ac.png";